export function fireDSPPixelEvent(eventName: string) {
  !(function (w, d, s, t, a) {
    if (w.amzn) return
    w.amzn = a = function () {
      w.amzn.q.push([arguments, new Date().getTime()])
    }
    a.q = []
    a.version = '0.0'
    s = d.createElement('script')
    s.src = 'https://c.amazon-adsystem.com/aat/amzn.js'
    s.id = 'amzn-pixel'
    s.async = true
    t = d.getElementsByTagName('script')[0]
    t.parentNode.insertBefore(s, t)
  })(window, document)
  window.amzn('setRegion', 'NA')
  window.amzn('addTag', '3a7cbdc9-33f8-421c-9f60-f5cff2cedb08')
  window.amzn('trackEvent', eventName)
}
